import cx from 'classnames';

import { useSearchResultsPageContext } from '~/pages/couples/explore/components/SearchResults/contexts/SearchResultsPageContext';
import { AllFacetParentKey, OptionFacetCategoryType } from '~/types/types';

import CalendarFacetButton from '../CalendarFacetButton/CalendarFacetButton';
import FacetButton from '../FacetButton/FacetButton';

import styles from './searchFacets.module.less';

export type SearchFacetsProps = {
  /** list of all categories and their child facets available */
  categories: OptionFacetCategoryType[];

  /** function to open and close side drawer */
  setDrawerOpenTo: (value: AllFacetParentKey | null | true) => void;

  isStickyActive: boolean;
};
/**
 * The row of search facet dropdown buttons at the top of the search page
 * @param {*} props
 */
export const SearchFacets = (props: SearchFacetsProps) => {
  const { categories, setDrawerOpenTo, isStickyActive } = props;

  const { selectedFacetOptions } = useSearchResultsPageContext();

  return (
    <div
      className={cx(styles.searchFacetsContainer, {
        [styles.active]: isStickyActive,
      })}
    >
      {categories.map((category) => {
        if (category.key === 'availability') {
          return (
            <CalendarFacetButton
              name="Availability"
              key="availability-facet"
              openSideDrawer={() => {
                setDrawerOpenTo(category.key);
              }}
              isImportant={category.isImportant}
            />
          );
        }

        if (
          !category.dependsOnKey ||
          selectedFacetOptions?.some(
            (selectedFacetOption) => selectedFacetOption.key === category.dependsOnKey
          )
        ) {
          return (
            <FacetButton
              isImportant={category.isImportant}
              category={category}
              key={category.key || category.displayName}
              openSideDrawer={() => {
                setDrawerOpenTo(category.key);
              }}
            />
          );
        }

        return null;
      })}
    </div>
  );
};
